import axios from '@/libs/axios'

export default {
  // Subscription
  getSubscriptionInvoices({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'finance/subscription-invoice/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  getSubscriptionInvoice({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({ url: `finance/subscription-invoice/${id}`, method: 'GET' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  addSubscriptionInvoice({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'finance/subscription-invoice/', method: 'POST', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  editSubscriptionInvoice({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `finance/subscription-invoice/${data.id}/`, method: 'PATCH', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  deleteSubscriptionInvoice({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({ url: `finance/subscription-invoice/${id}/`, method: 'DELETE' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  getSubscriptionPeriods() {
    return new Promise((resolve, reject) => {
      axios({ url: 'finance/subscription/subscription-period/', method: 'GET' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  // Sms balance
  getSmsBalancePointsPrices() {
    return new Promise((resolve, reject) => {
      axios({ url: 'finance/sms-balance/point-price/', method: 'GET' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  getSmsBalanceInvoices({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'finance/sms-balance-invoice/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  getSmsBalanceInvoice({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({ url: `finance/sms-balance-invoice/${id}`, method: 'GET' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  addSmsBalanceInvoice({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'finance/sms-balance-invoice/', method: 'POST', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  editSmsBalanceInvoice({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `finance/sms-balance-invoice/${data.id}/`, method: 'PATCH', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  deleteSmsBalanceInvoice({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({ url: `finance/sms-balance-invoice/${id}/`, method: 'DELETE' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
}
